import styled from 'styled-components'

export const GroupInfoHeader = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 8px 16px;

  .ant-divider-horizontal.ant-divider-with-text {
    margin-top: 8px;
  }
`

export const GroupInfoInnerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-size: 14px;
  div {
    padding: 4px 0px;
  }
`

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const UserBrandTable = styled.div`
  border: 1px solid black;
  border-radius: 2px;

  .ant-table-wrapper .ant-table-thead > tr > th, .ant-table-wrapper .ant-table-thead > tr > td {
    border-radius: none;
    background-color: white;
    color: black;
  
    &:hover{
      background-color: rgb(215, 212, 212);
    }
  }

  .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:first-child, :where(.css-dev-only-do-not-override-dwq01g).ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child {
    border-start-start-radius: 0px;
    border-start-end-radius: 0px;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 42px;
  gap: 8px;
`

export const CheckboxGroupGrid = styled.div`
  .ant-checkbox-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .ant-checkbox-wrapper+.ant-checkbox-wrapper {
    margin-inline-start: 0px
  }
`

export const TreeWrapper = styled.div`
  .ant-form-item .ant-form-item-control-input {
    min-height: 0px !important;
  }
`
